// extracted by mini-css-extract-plugin
export default {"StudentSelects":"StudentSelects_StudentSelects__z+wV6","faculty":"StudentSelects_faculty__y25DI","input":"StudentSelects_input__Vk1Rt"};